import { useEffect, useState } from "react";
import api from "@/lib/api";
import { GlassCard, PageLoader } from "@/components/shared";
import { Users, Server, HardDrive, DollarSign, TrendingUp, AlertTriangle, LifeBuoy, Percent } from "lucide-react";

export default function AdminDashboard() {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setO(r.data)); }, []);
  if (!o) return <PageLoader />;

  const cards = [
    { icon: Users, label: "Customers", value: o.customers },
    { icon: Server, label: "Active Servers", value: o.active_servers, sub: `${o.provisioning_servers} provisioning · ${o.offline_servers} offline` },
    { icon: HardDrive, label: "Total Storage", value: `${o.total_storage_tb} TB`, sub: `${o.storage_utilization}% utilized` },
    { icon: DollarSign, label: "MRR", value: `$${o.mrr.toLocaleString()}`, sub: `ARR $${o.arr.toLocaleString()}` },
    { icon: TrendingUp, label: "ARPU", value: `$${o.arpu}`, sub: `${o.new_customers} total customers` },
    { icon: Percent, label: "Gross Margin", value: `${o.gross_margin}%`, warn: o.gross_margin < 50 },
    { icon: AlertTriangle, label: "Failed Payments", value: o.failed_payments, warn: o.failed_payments > 0 },
    { icon: LifeBuoy, label: "Open Tickets", value: o.open_tickets },
  ];

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-50">Control Plane Overview</h1>
      <p className="mb-6 text-sm text-slate-400">Multi-tenant infrastructure & revenue desk</p>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {cards.map((c) => (
          <GlassCard key={c.label} className={`p-5 ${c.warn ? "border-amber-500/40" : ""}`}>
            <div className="flex items-center gap-2 text-slate-500"><c.icon className={`h-4 w-4 ${c.warn ? "text-amber-400" : ""}`} /><span className="text-xs uppercase">{c.label}</span></div>
            <div className={`mt-3 font-display text-2xl font-bold ${c.warn ? "text-amber-300" : "text-slate-50"}`}>{c.value}</div>
            {c.sub && <div className="mt-1 text-xs text-slate-500">{c.sub}</div>}
          </GlassCard>
        ))}
      </div>

      <GlassCard className="mt-6 p-6">
        <h2 className="mb-4 font-display font-semibold text-slate-100">Forecast cloud bill</h2>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {[["Current month", `$${o.infra_cost.toLocaleString()}`], ["Projected", `$${o.projected_infra_cost.toLocaleString()}`], ["Revenue", `$${o.mrr.toLocaleString()}`], ["Infra gross margin", `${o.gross_margin}%`]].map(([k, v]) => (
            <div key={k} className="rounded-lg border border-slate-800 bg-[#06080D] p-4">
              <div className="text-xs text-slate-500">{k}</div>
              <div className="mt-1 font-display text-xl font-bold text-cyan-300">{v}</div>
            </div>
          ))}
        </div>
        {o.gross_margin < 50 && <div className="mt-4 rounded-lg border border-rose-500/30 bg-rose-500/5 p-3 text-sm text-rose-300">⚠ Projected gross margin is below the 50% floor. Target is 60–75%.</div>}
      </GlassCard>
    </div>
  );
}
